export { VerifiedTeamLozenge } from '../src/teams/VerifiedTeamLozenge.tsx';
